import { createNamespace } from '../utils';

var _createNamespace = createNamespace('image-preview'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export { createComponent, bem };


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/image-preview/shared.js
// module id = 381
// module chunks = 77